'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fullscreenProviderLicense = require('./fullscreenProviderLicense.js');

var _fullscreenProviderLicense2 = _interopRequireDefault(_fullscreenProviderLicense);

var _fullscreenCartButton = require('./fullscreenCartButton.js');

var _fullscreenCartButton2 = _interopRequireDefault(_fullscreenCartButton);

var _fullscreenCheckoutLink = require('./fullscreenCheckoutLink.js');

var _fullscreenCheckoutLink2 = _interopRequireDefault(_fullscreenCheckoutLink);

var _ProductsList = require('./ProductsList.js');

var _ProductsList2 = _interopRequireDefault(_ProductsList);

var _mobileViewTypes = require('wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes');

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _utils = require('../utils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeComponentPosition = {
  top: 1,
  bottom: 2
};

var FullscreenStoreBottomMobileBar = function (_React$Component) {
  (0, _inherits3.default)(FullscreenStoreBottomMobileBar, _React$Component);

  function FullscreenStoreBottomMobileBar(props) {
    (0, _classCallCheck3.default)(this, FullscreenStoreBottomMobileBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenStoreBottomMobileBar.__proto__ || (0, _getPrototypeOf2.default)(FullscreenStoreBottomMobileBar)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(FullscreenStoreBottomMobileBar, [{
    key: 'handleProviderAction',
    value: function handleProviderAction(type, data) {
      if (this.props.onProviderAction) {
        this.props.onProviderAction(type, data);
      }
    }
  }, {
    key: 'getStoreComponent',
    value: function getStoreComponent(_ref) {
      var _this2 = this;

      var type = _ref.type,
          data = _ref.data;

      var storeComponentData = {
        component: null,
        position: storeComponentPosition.top
      };
      switch (type) {
        case _mobileViewTypes2.default.singleProduct:
          storeComponentData.component = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_fullscreenProviderLicense2.default, {
              actions: this.props.actions,
              pricingData: data
            }),
            _react2.default.createElement(_fullscreenCartButton2.default, {
              cartItems: this.props.cartItems,
              onAddToCartRequest: function onAddToCartRequest() {
                return _this2.props.onAddToCartRequest();
              },
              styleParams: this.props.styleParams
            })
          );
          break;
        case _mobileViewTypes2.default.productsList:
          storeComponentData.position = storeComponentPosition.bottom;
          storeComponentData.component = _react2.default.createElement(_ProductsList2.default, {
            data: data,
            onProviderAction: function onProviderAction(type, data) {
              return _this2.handleProviderAction(type, data);
            }
          });
          break;
        default:
          storeComponentData.component = _react2.default.createElement(
            'div',
            { className: 'store-preload' },
            _react2.default.createElement('div', {
              className: 'pro-circle-preloader',
              ref: function ref(_ref2) {
                return _this2.loader = _ref2;
              }
            })
          );
          break;
      }

      return storeComponentData;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var curItem = _lodash2.default.get(this.props, 'item') || _lodash2.default.get(this.props, 'current.item');
      var isImage = curItem.type === ('image' || 'picture');
      var providerView = this.props.providerView;

      if (!providerView) {
        return null;
      }
      var selectedLicense = null,
          shopButtons = null;
      if (isImage) {
        selectedLicense = this.getStoreComponent(providerView);
        shopButtons = _react2.default.createElement(_fullscreenCheckoutLink2.default, {
          cartItemsCount: this.props.cartItemsCount,
          onClick: function onClick() {
            return _this3.props.onClick();
          }
        });
      }

      var titleText = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten
      var title = titleText && this.props.styleParams.allowTitleExpand ? _react2.default.createElement(
        'div',
        { className: 'fullscreen-side-bar-title' },
        titleText
      ) : '';

      var descriptionText = curItem.description || ''; //(curItem.isDemo ? curItem.demoDescription : ''); - remove default text from demo items until rewritten
      var descriptionTextArray = descriptionText.split('\n');
      var description = void 0;
      if (descriptionText && this.props.styleParams.allowDescriptionExpand) {
        var descriptionElementsArray = [];
        for (var i = 0; i < descriptionTextArray.length; i++) {
          descriptionElementsArray.push(_react2.default.createElement(
            'div',
            {
              className: 'fullscreen-side-bar-description-line',
              key: 'description_' + i
            },
            descriptionTextArray[i]
          ));
        }

        description = _react2.default.createElement(
          'div',
          { className: 'fullscreen-side-bar-description' },
          descriptionElementsArray
        );
      } else {
        description = '';
      }

      var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link pro-fullscreen-store';
      var link = curItem.hasLink && this.props.styleParams.allowLinkExpand ? curItem.linkType === 'web' ? _react2.default.createElement(
        'a',
        {
          className: linkClassNames,
          href: !curItem.isWixUrl && curItem.linkUrl,
          onClick: function onClick() {
            return curItem.isWixUrl && _this3.props.actions.navigate(curItem);
          },
          target: curItem.linkOpenType
        },
        curItem.linkText || curItem.linkUrl
      ) : _react2.default.createElement(
        'div',
        {
          className: linkClassNames,
          onClick: function onClick() {
            return _this3.props.actions.navigate(curItem);
          }
        },
        curItem.linkText || curItem.linkUrl
      ) : '';

      var shouldRenderSelectedLicenseOnTop = selectedLicense && selectedLicense.position === storeComponentPosition.top;
      var shouldRenderSelectedLicenseOnBottom = selectedLicense && selectedLicense.position === storeComponentPosition.bottom;

      return _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-bottom-mobile-info pro-fullscreen-store',
          style: {
            textAlign: this.props.styleParams.galleryAlignExpand,
            height: '100%'
          }
        },
        shouldRenderSelectedLicenseOnTop ? [selectedLicense.component, shopButtons] : null,
        _react2.default.createElement(
          'div',
          {
            className: 'fullscreen-side-bar-info-container pro-fullscreen-store'
          },
          _react2.default.createElement(
            'div',
            {
              ref: function ref(itemContainer) {
                _this3.itemContainer = itemContainer;
              }
            },
            title,
            description
          ),
          link
        ),
        shouldRenderSelectedLicenseOnBottom ? [selectedLicense.component, shopButtons] : null
      );
    }
  }]);
  return FullscreenStoreBottomMobileBar;
}(_react2.default.Component);

exports.default = FullscreenStoreBottomMobileBar;